import { useMemo } from 'react';

import { useLocale } from '@adsk/alloy-react-locale';

import { DEFAULT_INCREMENT, SelectTime, TIME_PERIODS } from '../consts';

const MINUTES_IN_DAY = 60 * 24;

const useSelectableTimes = ({
  increment = DEFAULT_INCREMENT,
  is12Hour,
}: {
  increment?: number;
  is12Hour: boolean;
}) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  const amString = T.translate(TIME_PERIODS.AM);
  const pmString = T.translate(TIME_PERIODS.PM);

  return useMemo(() => {
    const times: SelectTime[] = [];
    let hours = 0;
    let minutes = 0;
    let period = amString;

    for (let counter = 0; counter < MINUTES_IN_DAY; counter += increment) {
      if (minutes >= 60) {
        minutes = 0;
        hours++;
      }

      if (hours >= 24) {
        minutes += increment;
        continue;
      }

      let label;
      const minuteString = minutes.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });

      if (is12Hour) {
        let hourValue = hours % 12;

        if (!hourValue) {
          hourValue = 12;
        }

        if (hours >= 12) {
          period = pmString;
        }
        label = `${hourValue}:${minuteString} ${period}`;
      } else {
        label = `${hours}:${minuteString}`;
      }

      times.push({
        value: { hours, minutes },
        label,
      });

      minutes += increment;
    }

    return times;
  }, [amString, increment, is12Hour, pmString]);
};

export default useSelectableTimes;
